import { serializable, alias, primitive } from "serializr";

export class CaseFilterParams {
  @serializable(alias("scan_center_id", primitive()))
  scanCenterId?: number;

  @serializable(alias("scan_center_branch_id", primitive()))
  scanCenterBranchId?: number;

  @serializable(alias("from_date", primitive()))
  fromDate?: string;

  @serializable(alias("to_date", primitive()))
  toDate?: string;

  @serializable(alias("acquisition_from_date", primitive()))
  acquisitionFromDate?: string;

  @serializable(alias("acquisition_to_date", primitive()))
  acquisitionToDate?: string;

  @serializable(alias("referring_doctor", primitive()))
  referringDoctor?: string;

  @serializable(alias("interesting_keyword", primitive()))
  interestingKeyword?: string;

  @serializable(alias("doctor_id", primitive()))
  doctorId?: number;

  @serializable(alias("telerad_admin_id", primitive()))
  teleradAdminId?: number;

  @serializable(alias("scan_center_admin_id", primitive()))
  scanCenterAdminId?: number;

  @serializable(alias("scan_type_id", primitive()))
  scanTypeId?: number;

  @serializable(alias("body_part_id", primitive()))
  bodyPartId?: number;

  @serializable(alias("status", primitive()))
  status?: string;

  @serializable(alias("tag_id", primitive()))
  tagId?: number;

  @serializable(alias("patient_name", primitive()))
  patientName?: string;

  @serializable(alias("patient_id", primitive()))
  patientId?: string;

  @serializable(alias("page", primitive()))
  page?: number;

  @serializable(alias("per_page", primitive()))
  perPage?: number;
}
